import { SystemFile } from '../../organisation/models/system-file'
import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { StreamCommissionResult } from './stream-commission-result'

@Mapped(
  {
    file: { format: SystemFile.create },
    results: { format: StreamCommissionResult.create },
  },
  ['numericID', 'timestamps']
)
export class StreamCommissionImage extends Mappable {
  id!: number
  numericID!: number
  ulid!: string
  file?: SystemFile
  results!: StreamCommissionResult[]
  created!: Date
  updated!: Date
  deleted!: boolean

  static create<Data>(attrs: Data) {
    return new StreamCommissionImage().map(attrs)
  }
}
